import { render, staticRenderFns } from "./TelegramActivationButton.vue?vue&type=template&id=31c02abb&"
import script from "./TelegramActivationButton.vue?vue&type=script&lang=ts&"
export * from "./TelegramActivationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports